import { ELEVATED_ROUTE_USER_IDS, routeAccessMap } from '@/router/access-map'
import type { RouteAccessContext, RouteAccessKey, RouteAccessRule } from '@/router/access-map'

interface RouteAccessMeta {
  accessKey?: RouteAccessKey
}

interface RouteAccessTarget {
  matched?: Array<{
    meta?: RouteAccessMeta
  }>
  meta?: RouteAccessMeta
}

// 从当前命中的 matched 链上反向查找 accessKey：
// - 优先使用最内层子路由自己的 accessKey
// - 子路由未声明时，继承最近的父级 accessKey
export function resolveRouteAccessKey(route: RouteAccessTarget): RouteAccessKey | null {
  if ('matched' in route && Array.isArray(route.matched) && route.matched.length > 0) {
    for (let index = route.matched.length - 1; index >= 0; index -= 1) {
      const accessKey = route.matched[index].meta?.accessKey
      if (accessKey) {
        return accessKey
      }
    }
  }

  return route.meta?.accessKey ?? null
}

// 按 accessKey 命中路由权限规则。
// 约定：
// - 未声明 accessKey 的路由默认放行，避免影响历史未接入页面
// - 已声明 accessKey 但规则表中不存在时默认拒绝，避免配置遗漏被静默放过
export function canAccessRouteByKey(accessKey: RouteAccessKey | null | undefined, context: RouteAccessContext): boolean {
  if (!accessKey) {
    return true
  }

  const rule: RouteAccessRule | undefined = routeAccessMap[accessKey]
  if (!rule) {
    return false
  }

  const hasElevatedAccess = context.superAdmin || ELEVATED_ROUTE_USER_IDS.includes(context.userId as (typeof ELEVATED_ROUTE_USER_IDS)[number])

  if (rule.requireElevatedAccess && !hasElevatedAccess) {
    return false
  }

  if (rule.denyInBuView && context.isBuHeaderView) {
    return false
  }

  if (rule.requireBuView && !context.isBuHeaderView) {
    return false
  }

  if (rule.denyWhenCommissionModuleHidden && context.hiddenCommissionModule) {
    return false
  }

  return true
}
